<template>
  <v-container fluid class="pricelist-edit mt-3 mx-1">
    <v-row>
      <v-col cols="12" centered>
        <v-tabs
          color="primary"
        >
          <v-tab
            :href="`#tab-pricelist`"
            class="mr-5"
          >
            <v-icon class="mr-3">mdi-file-document</v-icon>
            Price List
          </v-tab>
          <v-tab
            class="mr-5"
            :href="`#tab-groups`"
          >
            <v-icon class="mr-3">mdi-playlist-check</v-icon>
            Prices
          </v-tab>
          <v-tab-item
            :value="'tab-pricelist'"
          >
            <v-card
              elevation="0"
              flat
              tile
            >
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">Edit Price List</p>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePriceList($event, 'pricelistcode')"
                        v-bind:value="initvalue.pricelistcode"
                        placeholder="PriceList Code"
                        persistent-hint
                        single-line hint="Enter the pricelist code">
                      </v-text-field>
                      <v-text-field
                        class="mb-4"
                        outlined
                        dense
                        v-on:change="onChangePriceList($event, 'pricelistname')"
                        v-bind:value="initvalue.pricelistname"
                        placeholder="PriceList Name"
                        persistent-hint
                        single-line hint="Enter the pricelist name">
                      </v-text-field>
                    </v-form>
                  </v-col>
                  <v-col cols="12" md="3">
                    <v-form>
                      <p class="text-h5">&nbsp;</p>
                      <v-select
                        class="mb-4"
                        :items=pricelisttype
                        :value="initvalue.pricelisttype"
                        outlined
                        dense
                        v-on:change="onChangePriceList($event, 'pricelisttype')"
                        placeholder="Type"
                        persistent-hint
                        single-line hint="Please choose the pricelist type">
                      </v-select>
                      <v-select
                          class="mb-4"
                          :items="[{text: 'None', value: null}, ...saleschannels.map(x => {return {text: x.channelname, value: x._id};})]"
                          :value="initvalue.channelid"
                          v-on:change="onChangePriceList($event, 'channelid')"
                          outlined
                          dense
                          placeholder="Channel"
                          persistent-hint
                          single-line hint="Please choose the channel">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="[{text: 'None', value: null}, ...locations.map(x => {return {text: x.locationname, value: x._id};})]"
                          :value="initvalue.locationid"
                          v-on:change="onChangePriceList($event, 'locationid')"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="6">
                    <div class="d-flex justify-center">
                        <v-btn
                            to="/pricelist/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="editPriceList()">
                            Save
                          </v-btn>
                      </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
          <v-tab-item :value="'tab-groups'">
            <v-card elevation="0" flat tile>
              <v-card-text>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <v-row>
                      <v-col md="11">
                        <p class="text-h5">Prices</p>
                      </v-col>
                      <v-col md="1">
                        <v-btn
                          class="button-shadow"
                          color="secondary"
                          @click="isAddPrice = true"
                        >
                          Add
                        </v-btn>
                      </v-col>
                    </v-row>
                    <v-form>
                      <v-data-table
                        sort-by="pricename"
                        :headers="header_prices"
                        :items="data_prices"
                        :items-per-page="500"
                        :footer-props="footer"
                        class="elevation-0"
                      >
                        <template v-slot:top>
                          <v-dialog v-model="isDeletePrice" width="500">
                            <v-card>
                              <v-card-title> Delete this Price? </v-card-title>
                              <v-card-text>
                                {{ delete_price.pricename }}
                              </v-card-text>
                              <v-divider></v-divider>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  color="primary"
                                  outlined
                                  @click="isDeletePrice = false"
                                  >Cancel</v-btn
                                >
                                <v-btn
                                  color="secondary"
                                  class="button-shadow"
                                  @click="deletePrice(delete_price)"
                                  >Delete
                                </v-btn>
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                        </template>
                        <template v-slot:item.itemid="{ item }">
                          {{ items.length!==0 ? items.find(i=>i._id == item.itemid)['itemname'] : ''  }}
                        </template>                    
                        <template v-slot:item.pricename="{ item }">
                          <p class="two-line">{{ item.pricename }}</p>
                          <p class="two-line">{{ item.pricecode }}</p>
                        </template>
                        <template v-slot:item.minqty="{ item }">
                          <p class="two-line">{{ item.minqty }} - {{ item.maxqty  }}</p>
                        </template>
                        <template v-slot:item.foc="{ item }">
                          <div v-if="item.foc!=null && item.foc.enable==true">
                            <p v-if="item.foc.itemqty && item.foc.getitemqty" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Buy:</span> {{ item.foc.itemqty }} x {{ items.length!==0 ? items.find(i=>i._id == item.itemid)['itemname'] : ''  }}</p>
                            <p v-if="item.foc.itemid" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Get:</span> {{ item.foc.getitemqty !=null ? item.foc.getitemqty.toFixed(4) : 0 }} x {{ items.length!==0 ? items.find(i=>i._id == item.foc.itemid)['itemname'] : ''  }}</p>
                            <p v-if="item.foc.itemsubcategoryid!=null" class="two-line"><span style="font-size: 10pt; font-weight: bold;">Get Group:</span> {{ itemsubcategories.length!==0 && itemsubcategories.find(i=>i._id == item.foc.itemsubcategoryid)!=null ? itemsubcategories.find(i=>i._id == item.foc.itemsubcategoryid)['itemsubcategoryname'] : ''  }}</p>
                          </div>
                        </template>    
                        <template v-slot:item.createdAt="{ item }">
                          {{
                            new Date(item.createdAt).toLocaleString("en-SG", {
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                            })
                          }}
                        </template>
                        <template v-slot:item.actions="{ item }">
                          <v-tooltip bottom>
                            <template #activator="{ on }">
                              <v-btn 
                                icon 
                                v-on="on"
                                color="primary"
                                @click="editPriceFocDialog(item)"
                              >
                                <v-icon>mdi-playlist-edit</v-icon>
                              </v-btn>
                            </template>
                            <span>Edit FOC</span>
                          </v-tooltip>
                          <v-btn
                            icon
                            color="primary"
                            @click="editPriceDialog(item)"
                          >
                            <v-icon>mdi-pencil</v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            color="primary"
                            @click="deletePriceDialog(item)"
                          >
                            <v-icon>mdi-close</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-form>
                  </v-col>
                </v-row>
                <v-row justify="center">
                  <v-col cols="12" md="12">
                    <div class="d-flex justify-center">
                      <v-btn
                        to="/pricelist/list"
                        replace
                        outlined
                        color="primary"
                      >
                        Done
                      </v-btn>
                      <v-spacer></v-spacer>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
    <v-row>
      <v-dialog
          v-model="isAddPrice"
          persistent
          width="800px"
          max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Add Price</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-form>
                  <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Item"
                        single-line hint="Please choose the item"
                        :items="items.length>0 ? items.map(x => {
                            return {text: x.itemname, value: x._id};
                          }) : []"
                        v-model="add_price.itemid"
                        v-bind:error="errorindex == 20"
                      >
                      </v-select>
                  <v-text-field
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Price Name"
                    persistent-hint
                    single-line hint="Enter the price name"
                    v-model="add_price.pricename"
                    v-bind:error="errorindex == 21"
                  >
                  </v-text-field>
                  <v-text-field
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Currency"
                    v-model="add_price.currency"
                    v-bind:error="errorindex == 22"
                    single-line hint="Enter the currency"
                  >
                  </v-text-field>
                  <v-select
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Unit"
                    single-line hint="Please choose the unit"
                    :items="['Ctn', 'Doz', 'Pak', 'Box', 'Bot', 'Can', 'Bag']"
                    v-model="add_price.unit"
                    v-bind:error="errorindex == 23"
                  >
                  </v-select>
                </v-form>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="Min Qty"
                  persistent-hint
                  single-line hint="Enter the min quantity"
                  v-model="add_price.minqty"
                  v-bind:error="errorindex == 24"
                >
                </v-text-field>
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="Max Qty"
                  persistent-hint
                  single-line hint="Enter the max quantity"
                  v-model="add_price.maxqty"
                  v-bind:error="errorindex == 25"
                >
                </v-text-field>
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="List Price"
                  persistent-hint
                  single-line hint="Enter the list price"
                  v-model="add_price.listprice"
                  v-bind:error="errorindex == 26"
                >
                </v-text-field>
                </v-col>
              </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isAddPrice = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="addPriceRequest"
              >
                Save
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="isEditPrice"
          persistent
          width="800px"
          max-width="800px"
      >
      <v-card>
        <v-card-title>
          <span class="text-h5">Edit Price</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" md="6">
                <v-form>
                  <v-select
                        class="mb-4"
                        outlined
                        dense
                        persistent-hint
                        placeholder="Item"
                        single-line hint="Please choose the item"
                        :items="items.length>0 ? items.map(x => {
                            return {text: x.itemname, value: x._id};
                          }) : []"
                        v-on:change="onChangePrice($event, 'itemid')"
                        :value="edit_price.itemid"
                      >
                      </v-select>
                  <v-text-field
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Price Name"
                    persistent-hint
                    single-line hint="Enter the price name"
                    v-on:change="onChangePrice($event, 'pricename')"
                    :value="edit_price.pricename"
                  >
                  </v-text-field>
                  <v-text-field
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Currency"
                    v-on:change="onChangePrice($event, 'currency')"
                    :value="edit_price.currency"
                    single-line hint="Enter the currency"
                  >
                  </v-text-field>
                  <v-select
                    class="mb-4"
                    outlined
                    dense
                    persistent-hint
                    placeholder="Unit"
                    single-line hint="Please choose the unit"
                    :items="['Ctn', 'Doz', 'Pak', 'Box', 'Bot', 'Can', 'Bag']"
                    v-on:change="onChangePrice($event, 'unit')"
                    :value="edit_price.unit"
                  >
                  </v-select>
                </v-form>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="Min Qty"
                  persistent-hint
                  single-line hint="Enter the min quantity"
                  v-on:change="onChangePrice($event, 'minqty')"
                  :value="edit_price.minqty"
                >
                </v-text-field>
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="Max Qty"
                  persistent-hint
                  single-line hint="Enter the max quantity"
                  v-on:change="onChangePrice($event, 'maxqty')"
                  :value="edit_price.maxqty"
                >
                </v-text-field>
                <v-text-field
                  class="mb-4"
                  type="number"
                  outlined
                  dense
                  placeholder="List Price"
                  persistent-hint
                  single-line hint="Enter the list price"
                  v-on:change="onChangePrice($event, 'listprice')"
                  :value="edit_price.listprice"
                >
                </v-text-field>
                </v-col>
              </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="blue darken-1"
                text
                @click="isEditPrice = false"
              >
                Close
              </v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="editPriceRequest"
              >
                Save
              </v-btn>
            </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog
          v-model="isEditFoc"
          persistent
          width="800px"
          max-width="800px"
        >
          <v-card>
          <v-card-title>
            <span class="text-h5">Edit Foc</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    class="mb-4"
                    type="number"
                    outlined
                    dense
                    v-on:change="onChangeFoc($event, 'itemqty')"
                    v-bind:value="edit_foc.itemqty"
                    placeholder="Item Qty"
                    persistent-hint
                    single-line hint="Enter the purchase item quantity">
                  </v-text-field>
                  <v-text-field
                    class="mb-4"
                    type="number"
                    outlined
                    dense
                    v-on:change="onChangeFoc($event, 'getitemqty')"
                    v-bind:value="edit_foc.getitemqty"
                    placeholder="FOC Item Qty"
                    persistent-hint
                    single-line hint="Enter the FOC item quantity">
                  </v-text-field>
                  <v-switch
                    v-model="edit_foc.enable"
                    v-on:change="onChangeFoc($event, 'enable')"
                    v-bind:label="edit_foc.enable==true ? 'true' : 'false'"
                    :value="edit_foc.enable"
                    :true-value="true"
                    :false-value="false"
                  ></v-switch>
                </v-col>
                <v-col cols="12" md="6">
                    <v-form>
                      <v-select
                        class="mb-4"
                        :items="['Item', 'Subcategory Item', null]"
                        :value="edit_foc.type"
                        outlined
                        dense
                        v-on:change="onChangeFoc($event, 'type')"
                        placeholder="FOC Item Type"
                        persistent-hint
                        single-line hint="Please choose the FOC Item Type">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...items.map(x => {return {text: x.itemname, value: x._id}})
                        ]"
                        :value="edit_foc.itemid"
                        outlined
                        dense
                        v-on:change="onChangeFoc($event, 'itemid')"
                        placeholder="Item"
                        persistent-hint
                        single-line hint="Please choose the FOC item">
                      </v-select>
                      <v-select
                        class="mb-4"
                        :items="[
                          {text: 'None', value: null},
                          ...itemsubcategories.map(x => {return {text: x.itemsubcategoryname, value: x._id}})
                        ]"
                        :value="edit_foc.itemsubcategoryid"
                        outlined
                        dense
                        v-on:change="onChangeFoc($event, 'itemsubcategoryid')"
                        placeholder="Item Subcategory"
                        persistent-hint
                        single-line hint="Please choose the FOC item subcategory">
                      </v-select>
                    </v-form>
                  </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditFoc = false"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editPriceFoc"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      isAddPrice: false,
      isEditPrice:false,
      isEditFoc:false,
      isDeletePrice: false,
      error: null,
      errorindex: null,
      initvalue: {},
      add_price: {},
      edit_pricelist: {},
      edit_price: {},
      edit_foc: {},
      change_price: {},
      change_foc: {},
      delete_price: {},
      footer: {'items-per-page-options': [100, 500, 1000, 5000]},
      data_prices: [],
      pricelisttype: ['Sales', 'Purchasing', 'Other'],
      header_prices: [
        { text: 'Name', value: 'pricename', width: '8%' },
        { text: 'Item', value: 'itemid', width: '15%' },
        { text: 'Min Max Qty', value: 'minqty', width: '10%' },
        { text: 'Price', value: 'listprice', width: '10%'},
        { text: 'Foc', value: 'foc' },
        { text: "Actions", value: "actions", sortable: false , width: "12%"},
      ],
    }
  },
  methods: {
    ...mapActions('SalesChannel', ['getSalesChannelsRequest']),
    ...mapActions('Price', ['deletePriceRequest', 'insertPriceRequest', 'updatePriceRequest', 'updateFocRequest']),
    ...mapActions('PriceList', ['updatePriceListRequest','getPriceListsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('ItemSubcategory', ['getItemSubcategoriesRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    async addPriceRequest() {
      this.isAddPrice = false;
      this.add_price.pricelistid = this.initvalue._id;
      let result = await this.insertPriceRequest(this.add_price);
      this.data_prices.push(result);
      this.add_price = {};
    },
    async deletePrice(payload) {
      this.isDeletePrice = false;
      let response = await this.deletePriceRequest(payload);
      let index = this.data_prices.findIndex((trans) => trans._id == response._id);
      this.data_prices.splice(index, 1);
    },
    deletePriceDialog(item) {
      this.isDeletePrice = true;
      this.delete_price = {
        _id: item._id,
        pricename: item.pricename,
      };
    },
    editPriceDialog(item) {
      this.edit_price = Object.assign({}, item);
      this.change_price = {};
      this.isEditPrice = true;
    },
    editPriceList() {
      this.edit_pricelist._id = this.initvalue._id;
      this.updatePriceListRequest(this.edit_pricelist);
      this.getPriceListsRequest();
      router.push('/pricelist/list');
    },
    async editPriceRequest() {
      this.isEditPrice = false;
      this.change_price._id = this.edit_price._id;
      let response = await this.updatePriceRequest(this.change_price);
      let index = this.data_prices.findIndex((x) => x._id == response._id);
      this.data_prices.splice(index, 1, response);
      this.edit_price = {};
      this.change_price = {};
    },
    async editPriceFoc() {
      this.isEditFoc = false;
      this.change_foc._id = this.edit_foc._id;
      let response = await this.updateFocRequest(this.change_foc);
      let index = this.data_prices.findIndex((price) => price._id == response._id);
      this.data_prices.splice(index, 1, response);
      this.edit_foc = {};
      this.change_foc = {};
    },
    editPriceFocDialog(item) {
      this.isEditFoc = true;
      this.edit_foc = {};
      this.change_foc = {};
      this.edit_foc = Object.assign({}, {_id: item._id}, item.foc);
    },
    onChangePriceList(value, field){
      this.edit_pricelist[field] = value;
    },
    onChangePrice(value, field){
      this.change_price[field] = value;
    },
    onChangeFoc(value, field){
      this.change_foc[field] = value;
    },
  },
  computed: {
    ...mapState('PriceList', ['pricelists', 'isReceiving']),
    ...mapState('Item', ['items']),
    ...mapState('ItemSubcategory', ['itemsubcategories']),
    ...mapState('Location', ['locations']),
    ...mapState('SalesChannel', ['saleschannels']),
  },
  async created () {
    this.initvalue = this.$route.params;
    this.data_prices = Object.assign([], this.initvalue.prices);
    console.log(this.data_prices)
    if(!this.initvalue._id) this.$router.push({ name: 'PricelistList' });
    if(this.items.length == 0) await this.getItemsRequest();
    if(this.itemsubcategories.length == 0) await this.getItemSubcategoriesRequest();
    if(this.pricelists.length == 0) await this.getPriceListsRequest();
    if(this.saleschannels.length==0) await this.getSalesChannelsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
  },
}
</script>

<style src="./Edit.scss" lang="scss"></style>
